module.exports = __webpack_public_path__ + "img/介绍.2ec6f6a6.png";